import CategoryIcon from "@mui/icons-material/Category";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListHigherEducationFields from "./List";
import CreateHigherEducationFields from "./Create";
import EditHigherEducationFields from "./Edit";
import ShowHigherEducationFields from "./Show";

export const resources = {
  isMenu: true,
  icon: <CategoryIcon />,
  name: `${DoctoralServicePath}higher-education-fields`,
  title: "Области на висше образование",
  list: <ListHigherEducationFields />,
  create: <CreateHigherEducationFields />,
  createPermission: permissions.canCreateHigherEducationFields,
  edit: <EditHigherEducationFields />,
  editPermission: permissions.canUpdateHigherEducationFields,
  show: <ShowHigherEducationFields />,
  permission: permissions.canPreviewHigherEducationFields,
};
